import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { DashboardtileComponent } from './dashboardtile/dashboardtile.component';
import { RouterModule } from '@angular/router';
import { FormsModule,ReactiveFormsModule} from '@angular/forms';
import { AddTransactionActionSheetComponent } from './add-transaction-action-sheet/add-transaction-action-sheet.component';
import { AddCategoryComponent } from './add-category/add-category.component';
import { VerificationActionSheetComponent } from './verification-action-sheet/verification-action-sheet.component';
import { DialogPopupComponent } from './dialog-popup/dialog-popup.component';
import { SubscriptionAlertComponent } from './subscription-alert/subscription-alert.component';
import { NumberSuffixPipe } from '../pipes/number-suffix.pipe';
import { SubscriptionPlansListComponent } from './subscription-plans-list/subscription-plans-list.component';
import { Page404Component } from './page404/page404.component';
import { StoreUnpublishAlertComponent } from './store-unpublish-alert/store-unpublish-alert.component';
import { StoreDeleteAlertComponent } from './store-delete-alert/store-delete-alert.component';
import { LegalDocsAlertComponent } from './legal-docs-alert/legal-docs-alert.component';
import { PayInComponent } from './pay-in/pay-in.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { PaymentMethodsComponent } from './payment-methods/payment-methods.component';
import { AutofocusDirective } from '../directives/autofocus.directive';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { NavbarComponent } from './navbar/navbar.component';
import { ServicenearNavbarComponent } from '../../third-party/service-near/servicenear-navbar/servicenear-navbar.component';
import { ServicenearSideMenuComponent } from '../../third-party/service-near/servicenear-side-menu/servicenear-side-menu.component';
import { TobeonlineSideMenuComponent } from './tobeonline-side-menu/tobeonline-side-menu.component';
import { TobeonlineNavbarComponent } from './tobeonline-navbar/tobeonline-navbar.component';
import { UniqueIdentifierComponent } from './unique-identifier/unique-identifier.component';
import { GoogleAccountSettingsComponent } from 'src/app/admin-pages/google-account-settings/google-account-settings.component';


@NgModule({
  declarations: [
    ToolbarComponent, 
    DashboardtileComponent, 
    AddTransactionActionSheetComponent, 
    AddCategoryComponent, 
    DialogPopupComponent, 
    SubscriptionAlertComponent,
    NumberSuffixPipe,
    SubscriptionPlansListComponent,
    Page404Component,
    StoreUnpublishAlertComponent,
    StoreDeleteAlertComponent,
    LegalDocsAlertComponent,
    PayInComponent,
    PaymentMethodsComponent,
    AutofocusDirective,
    SideMenuComponent,
    NavbarComponent,
    ServicenearNavbarComponent,
    ServicenearSideMenuComponent,
    TobeonlineSideMenuComponent,
    TobeonlineNavbarComponent,
    UniqueIdentifierComponent,
    GoogleAccountSettingsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
  ],
  exports:[
    ToolbarComponent,
    DashboardtileComponent,
    AddTransactionActionSheetComponent,
    AddCategoryComponent,
    DialogPopupComponent,
    SubscriptionAlertComponent,
    NumberSuffixPipe,
    SubscriptionPlansListComponent,
    StoreUnpublishAlertComponent,
    StoreDeleteAlertComponent,
    LegalDocsAlertComponent,
    PayInComponent,
    PaymentMethodsComponent,
    NavbarComponent,
    SideMenuComponent,
    ServicenearSideMenuComponent,
    ServicenearNavbarComponent,
    TobeonlineSideMenuComponent,
    TobeonlineNavbarComponent,
    UniqueIdentifierComponent,
    GoogleAccountSettingsComponent
  ]
})
export class ComponentsModule { }
